<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>调薪申请单说明:</h5>
        <span>1、单号构成规则:201201+TX+4位顺序号。系统生成,添加无效</span><br>
        <span>2、业务说明:调薪申请=>领导审核=>老板终审=>通过后修改对应工资数据!</span><br>
        <span>3、查询关键字:单号、部门、申请人。</span><br>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

      <!-- <template slot="slot_c_out_fee">
            <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
              :selectValue="sel_fee" />
          </template> -->

    </pre-base>
  </div>
</template>

<script>
  import api from '@/utils/type.js';
  import {
    Method_EasySelect
  } from '@/utils/loadhttpdata.js';
  export default {
    components: {
      "pre-base": () => import("../auto/old_view_v1.vue")
    },
    data() {
      return {
        init_data: '',
        row_id: '',
        item: '',
        // 下拉菜单
        // list_fee: [],
        // sel_fee: {},
      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.fun_init();
      });
    },
    methods: {
      fun_init:  function() {
        this.init_data = '';
        this.init_data = JSON.stringify({
          "title": '调薪申请',
          "control": "salaryapply",
          "isTwo": "1",
          "isTwoDetail":"1",
          "isFileMain":"1",
          "sel_action": 'exp_kq_s_apply',
          "upd_action": 'exp15_kq_s_apply',
          "detail_part":"0",
          "d_sel_action": '',
          "d_upd_action": '',
          "file_action": 's_apply',
          "p1": 'kq',
          "p2": 'salaryapply',
          "p3": '',
          "parm_sel": [
            {
              "name": "单号",
              "val": "",
              "key": "sheet_no",
              "type": "text",
              "class": "long1",
              "sel": "1"
            },
            {
              "name": "部门",
              "val": "",
              "key": "d_name",
              "type": "select",
              "class": "long1",
              "sel_action": '_base_dep',
              "sel_name": "",
              "sel": "2"
            },
            {
              "name": "申请人",
              "val": "",
              "key": "u2_name",
              "type": "select",
              "class": "long1",
              "sel_action": '_base_roleuser',
              "sel_name": "",
              "sel": "3"
            }
          ],
          "parm": [{
              "name": "单号",
              "val": "",
              "key": "sheet_no",
              "type": "text",
              "class": "long1",
              "p": "1",
              "r": "1",
              "x": "1"
            },
            {
              "name": "部门",
              "val": "",
              "key": "d_name",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "1"
            },
            {
              "name": "申请人",
              "val": "",
              "key": "u2_name",
              "type": "select",
              "class": "long1",
              "sel_action": '_base_roleuser',
              "sel_name": "",
              "p": "1",
              "x": "1"
            },
            {
              "name": "当前薪水",
              "val": "",
              "key": "old_salary",
              "type": "text",
              "class": "long1",
              "x": "2",
              "r": "1"
            },
            {
              "name": "调薪涨幅",
              "val": "",
              "key": "up_amount",
              "type": "number",
              "class": "long1",
              "p": "1",
              "x": "2"
            },
            {
              "name": "备注说明",
              "val": "",
              "key": "note",
              "type": "textareaedit",
              "class": "long3",
              "p": "1",
              "x": "3"
            }
          ],
          "parm_th": [{
              "name": "序号"
            },
            {
              "name": "申请单"
            },
            {
              "name": "部门"
            },
            {
              "name": "申请人"
            },
            {
              "name": "状态"
            },
            {
              "name": "当前薪水"
            },
            {
              "name": "调薪涨幅"
            },
            {
              "name": "备注说明"
            },
            {
              "name": "录入人"
            },
            {
              "name": "附件"
            },
            {
              "name": "路径1"
            },
            {
              "name": "路径2"
            },
            {
              "name": "更新时间"
            }
          ],
          "d_parm": [],
          "d_name": []
        });

      },
      refresh_data: function(type) {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data(type);
        });
      },
      refresh_father: function(type, val, parm) {
        // console.log('type=' + type + ' val=' + val);
        switch (type) {
          case 'father':
            // 弹出修改明细，修改主窗口信息
            this.refresh_data();
            break;
          default:
            // console.log('子组件刷新父组件传值=' + val);
            this.row_id = val;
            this.item = parm;
            break;
        }
      },






    }
  };
</script>
<style>
</style>
